import React from 'react';
import ListingImageGallery from './ListingImageGallery/ListingImageGallery';

import css from './ListingPage.module.css';

// Scaled variants in order from smallest to largest for proper srcset
const SCALED_VARIANTS = ['scaled-small', 'scaled-medium', 'scaled-large', 'scaled-xlarge'];
const THUMBNAIL_VARIANTS = ['scaled-small', 'scaled-medium'];

const SectionGallery = props => {
  const { listing } = props;
  const images = listing.images;
  const firstImage = images?.[0];
  const availableVariants = firstImage?.attributes?.variants
    ? Object.keys(firstImage.attributes.variants)
    : [];

  // Filter to only include variants that exist on the image
  const imageVariants = SCALED_VARIANTS.filter(v => availableVariants.includes(v));
  const thumbnailVariants = THUMBNAIL_VARIANTS.filter(v => availableVariants.includes(v));

  // Fallback to any available variants if scaled variants don't exist
  const finalImageVariants = imageVariants.length > 0 ? imageVariants : availableVariants;
  const finalThumbnailVariants = thumbnailVariants.length > 0 ? thumbnailVariants : finalImageVariants;

  return (
    <div className={css.productGallery} data-testid="carousel">
      <ListingImageGallery
        images={images}
        imageVariants={finalImageVariants}
        thumbnailVariants={finalThumbnailVariants}
      />
    </div>
  );
};

export default SectionGallery;
